<template>
	<div class="dis-fle">
		<div class="left">
			<div class="title">
				<span>{{ $t('资产分布') }}</span>
				<img src="@/assets/img-pc/59.df902e24.svg" class="hand" @click="$emit('refresh')">
			</div>

			<LineChart1 :data="list" :colorArr="colorArr"></LineChart1>
		</div>

		<div class="right flex-1">
			<div class="th-div">
				<div class="w20">{{ $t('账户类型') }}</div>
				<div class="w30">{{ $t('账户余额') }}</div>
				<div class="w25">{{ $t('今日收益') }}</div>
				<div class="w20">{{ $t('占比') }}</div>
				<!-- <div class="w15 txt-ali-cen">{{ $t('操作') }}</div> -->
			</div>

			<div class="tr-div" v-for="(item, index) in list" :key="item.id" :class="[`tr${index}`]">
				<div class="w20 td1">
					<span class="dot"></span>
					<span>{{ item.name }}</span>
				</div>
				<div class="w30 td2">${{ item.value }}</div>
				<div class="w25 td3">{{ item.profit }}</div>
				<div class="w20 td4">{{ item.percent }}%</div>
				<!-- <div class="w15 td5 txt-ali-cen">
					<el-dropdown>
						<i class="cur-poi">
							<svg focusable="false" data-icon="ellipsis" width="26" height="26" fill="currentColor"
								aria-hidden="true" viewBox="64 64 896 896">
								<path
									d="M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z">
								</path>
							</svg>
						</i>
						<template #dropdown>
							<el-dropdown-menu class="user-dropdown-menu">
								<el-dropdown-item>{{ $t('交易') }}</el-dropdown-item>
								<el-dropdown-item>{{ $t('划转') }}</el-dropdown-item>
							</el-dropdown-menu>
						</template>
					</el-dropdown>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>

const colorArr = ['#f09464', '#6dd2f8', '#b164e2', '#ff4834']

import LineChart1 from './LineChart1.vue';
export default {
	components: { LineChart1 },
	props: {
		list: {
			type: Array,
			default: () => []
		},
	},
	data() {
		return {
			colorArr,
		};
	},
	mounted() {
	},

	methods: {
	}
};
</script>
<style lang="scss" scoped>
.right {
	.th-div {
		display: flex;
		align-items: center;
		margin-bottom: 30px;
		color: #5e5e7a;
		font-size: 12px;
	}

	.tr-div {
		height: 70px;
		border-bottom: 1px solid #31323f;
		background: #000;
		display: flex;
		align-items: center;
		font-size: 16px;

		.td1 {
			background: radial-gradient(102.27% 102.27% at 83.82% 87.06%, #f09464 0, #f7be94 .01%, #f09464 100%);
			background-clip: text;
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;

			.dot {
				display: inline-block;
				width: 10px;
				height: 10px;
				border-radius: 50%;
				margin-right: 5px;
				background: linear-gradient(90deg, #f09464 49.79%, #d37442);
			}
		}

		&.tr1 {
			.td1 {
				background: radial-gradient(118.76% 101.38% at 0 22.64%, #147ec7 0, #6dd2f8 100%);
				background-clip: text;
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;

				.dot {
					background: linear-gradient(90deg, #6dd2f8 49.79%, #147ec7);
				}
			}
		}

		&.tr2 {
			.td1 {
				background: radial-gradient(45.13% 45.13% at 47.06% 6.18%, #d18bd7 0, #b164e2 100%);
				background-clip: text;
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;

				.dot {
					background: linear-gradient(90deg, #d18bd7 49.79%, #b164e2);
				}
			}
		}

		&.tr3 {
			.td1 {
				background: radial-gradient(45.13% 45.13% at 47.06% 6.18%, #ff4834 0, #ff4834 100%);
				background-clip: text;
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;

				.dot {
					background: linear-gradient(90deg, #ff4834 49.79%, #ff4834);
				}
			}
		}

		.td2 {}

		.td3 {
			color: #00f0ff;
		}

		.td4 {}

		.td5 {}
	}

	.w15 {
		width: 15%;
	}

	.w20 {
		width: 20%;
	}

	.w25 {
		width: 25%;
	}

	.w30 {
		width: 30%;
	}
}

.left {
	flex: none;
	display: flex;
	flex-direction: column;
	width: 170px;
	height: 347px;
	margin-right: 30px;

	.title {
		display: flex;
		align-items: center;
		height: 30px;
		line-height: 30px;
		font-size: 18px;
		margin-bottom: 74px;

		.hand {
			cursor: pointer;
			margin-left: 10px;
		}
	}

}
</style>